import React, { Component } from 'react';
import utils from '../../common/services/utils';
import { Link } from 'react-router-dom';
import { Glyphicon, Label } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { mapStatusToLabel } from './utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';

class Timeline extends Component {
	render() {
		const { data, schoolYears, t } = this.props;
		const schoolYearGroups = utils.groupBy(data, 'schoolYearId');

		return <div className='timeline'>
			<div className='spine' />
			{Object.keys(schoolYearGroups).sort((a, b) => a.id > b.id ? 1 : -1).map(key => {
				const schoolYear = schoolYears.find(x => x.id === Number(key));
				const paymentsInSchoolYear = schoolYearGroups[key].sort((a, b) => new Date(a.created) > new Date(b.created) ? -1 : 1);
				return <div key={key}>
					<div className='date_separator'>
						<span>{schoolYear ? schoolYear.name : key}</span>
					</div>
					<ul className='columns'>
						{paymentsInSchoolYear.map(x => <li key={x.id}>
							<div className='timeline_element teal' style={{ minWidth: '300px' }}>
								<div className='timeline_title'>
									<span className='timeline_label'>{x.name || x.grade}</span>
									<span className='timeline_date'>{x.term.name}</span>
								</div>
								<div className='content'>
									<div>
										<div>{t('PaymentHistory_Id')} {x.id} <Label bsStyle={mapStatusToLabel(x.status.id)}>{t(`PaymentStatusType_${x.status.name}`)}</Label></div>
										<div><Glyphicon glyph='map-marker' /> {x.center}</div>
										<div><Glyphicon glyph='calendar' /> {ui.formatDate(x.created)}</div>
										<div>{x.description}</div>
									</div>
								</div>
								<div className='readmore'>
									<Link to={`/paymentHistory/${x.id}`} className='btn btn-info'>{t('Common_View')} <FontAwesomeIcon icon={faArrowCircleRight} /></Link>
								</div>
							</div>
						</li>)}
					</ul>
				</div>;
			})}
		</div>;
	}
}

export default withTranslation()(Timeline);